import { useMemo } from 'react';
import { useCompareKeyMetricsTable } from '../../CompareKeyMetrics/hooks';
import { KeyMetricsType } from '../Community/constants';

export function useGetRankList({
  filter,
  gameData,
}: {
  filter: any;
  gameData: any;
}) {
  const { tableRecords, loading } = useCompareKeyMetricsTable({
    filter,
    gameData,
  });

  const data = useMemo(() => {
    const records = tableRecords.find(
      (item) => item?.edition_unified_id === filter?.edition_unified_id,
    );
    return records || {};
  }, [tableRecords]);

  function getRankList(key: KeyMetricsType) {
    const list = tableRecords.sort((a, b) => {
      const newB = b[key] || 0;
      const newA = a[key] || 0;

      if (newA !== newB) return newB - newA;

      return a.edition_unified_id === filter.edition_unified_id ? -1 : 1;
    });

    return {
      list: list.map((item: any) => {
        const gameInfo = gameData?.[item?.edition_unified_id] || {};
        return {
          edition_unified_id:
            gameInfo?.edition_unified_id || item?.edition_unified_id,
          cover: gameInfo?.cover,
          value: item[key] || 0,
          entity_name: gameInfo?.entity_name,
          entity_type: gameInfo?.entity_type,
        };
      }),
      rank:
        list.findIndex(
          (item) => item?.edition_unified_id === filter?.edition_unified_id,
        ) + 1,
    };
  }

  return { data, loading, getRankList };
}
